import {
  required,
  TextInput,
  SimpleForm,
  NumberInput,
  SelectInput,
  BooleanInput,
} from "react-admin";

const validateRequired = [required()];

const milestoneChoices = [
  { id: "first_contact", name: "Primeiro Contato" },
  { id: "interview_scheduled", name: "Entrevista Agendada" },
  { id: "started_work", name: "Iniciou Trabalho" },
  { id: "completed_onboarding", name: "Finalizou Integração" },
];

export const JobApplicationStatusForm = (props: Record<string, unknown>) => {
  return (
    <SimpleForm warnWhenUnsavedChanges {...props}>
      <TextInput 
        source="name" 
        validate={validateRequired} 
        label="resources.job-application-status.fields.name"
        fullWidth 
      />
      <NumberInput 
        source="order" 
        label="resources.job-application-status.fields.order"
        fullWidth 
      />

      <SelectInput
        source="triggersMilestone"
        choices={milestoneChoices}
        label="resources.job-application-status.fields.triggersMilestone"
        emptyText="Nenhum"
        parse={(value: string) => value === '' ? null : value}
        fullWidth
      />
      {/*
        triggersOutcome removed: the hire/terminal roles are now derived flags
        (marksOutcome / isTerminal / requiresClosureReason) set via the Pipeline
        roles setting in the WorkflowBuilder, not a free enum on the status. The
        BE create/update-status DTO no longer accepts triggersOutcome (it was
        silently stripped), and its old choices were pre-`closed` legacy values.
      */}

      <BooleanInput
        source="hidesFromKanban" 
        label="resources.job-application-status.fields.hidesFromKanban"
      />
      <NumberInput 
        source="autoHideAfterDays" 
        label="resources.job-application-status.fields.autoHideAfterDays"
        fullWidth 
      />
      <BooleanInput 
        source="isPostHire" 
        label="resources.job-application-status.fields.isPostHire"
      />
    </SimpleForm>
  );
};

export { JobApplicationStatusList } from './List';
export { JobApplicationStatusCreate } from './Create';
export { JobApplicationStatusEdit } from './Edit';
export { JobApplicationStatusIcon } from './Icon';
export { WorkflowBuilder } from './WorkflowBuilder';
